import { Box, Typography } from '@mui/material';

import Input from '../../../form/Input';
import Select from '../../../form/Select';
import PessoaProfissaoField from './PessoaProfissaoField';

export default function PessoaTabFisica({ module, EnumSexo, EnumTipoSanguineo, EnumEstadoCivil, optionsPais }) {
    const { dados } = module.state;
    const { change } = module.actions;

    return (
        <Box sx={{ display: 'grid', gap: 1 }}>
            <Typography variant="h6">Informações da pessoa física</Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Input
                    text="Data Nascimento"
                    type="date"
                    name="pessoaFisica.dataNascimento"
                    inputWidth="200px"
                    handleOnChange={change}
                    value={dados.dataNascimento || ''}
                />
                <Select
                    text="Sexo"
                    name="pessoaFisica.sexo"
                    options={EnumSexo}
                    handleOnChange={change}
                    value={dados.sexo || ''}
                    isEnum={true}
                />
                <Select
                    text="Tipo Sanguíneo"
                    name="pessoaFisica.tipoSanguineo"
                    options={EnumTipoSanguineo}
                    handleOnChange={change}
                    value={dados.tipoSanguineo || ''}
                    isEnum={true}
                />
                <Select
                    text="Estado Civil"
                    name="pessoaFisica.estadoCivil"
                    options={EnumEstadoCivil}
                    handleOnChange={change}
                    value={dados.estadoCivil || ''}
                    isEnum={true}
                />
                <Select
                    name="pessoaFisica.nacionalidadeId"
                    text="Nacionalidade"
                    title="Escolha o país de nascimento da pessoa"
                    options={optionsPais}
                    handleOnChange={change}
                    value={dados.nacionalidadeId || null}
                />
            </Box>
            <PessoaProfissaoField module={module} />
            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Input
                    text="Nome do Pai"
                    type="text"
                    name="pessoaFisica.pai"
                    placeholder="Nome"
                    title="nome do Pai da pessoa"
                    inputWidth="350px"
                    handleOnChange={change}
                    value={dados.pai || ''}
                    readonly={false}
                />

                <Input
                    text="Nome da Mãe"
                    type="text"
                    name="pessoaFisica.mae"
                    placeholder="Nome"
                    title="nome da Mãe da pessoa"
                    inputWidth="350px"
                    handleOnChange={change}
                    value={dados.mae || ''}
                    readonly={false}
                />
            </Box>
        </Box>
    );
}
